import baseAPI from '@/http'

const router = 'api/salaindicadornivel'

export const SalaIndicadorNivelApi = {
  create: (nivel) => baseAPI.post(router, nivel),
  update: (nivel) => baseAPI.put(router, nivel),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router)
}
